import PropTypes from 'prop-types';
import React from 'react';

import 'commons-forms/components/InputColorRadio/InputColorRadio.scss';

const InputColorRadio = ({ onChange, name, value, isSelected, disabled }) => {
    return (
        <div className="color-radio-wrapper">
            <input
                type="radio"
                name="color"
                id={name}
                checked={isSelected}
                onChange={() => onChange(name, value)}
                disabled={disabled}
            />
            <label id={name} className="color-radio-label" style={{ background: value }} htmlFor={name}>
                <span className="color-radio-box colorBox" />
            </label>
            <br />
            <font className="color-radio-wrapper--title">{name}</font>
        </div>
    );
};

InputColorRadio.defaultProps = {
    isRequired: false,
    isSelected: false,
    disabled: false,
};

InputColorRadio.propTypes = {
    name: PropTypes.string.isRequired,
    isSelected: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
};

InputColorRadio.displayName = 'InputColorRadio';

export default InputColorRadio;
